import type { CommentThread } from '../../lib/comment-types';

export type ThreadFilter = 'all' | 'open' | 'forMe' | 'resolved';

/**
 * The panel's filters (spec §I-P7, backlog §19 P16-3.2): `forMe` = threads I started or wrote in, or that mention or
 * answer me (`notified`: threads with an unread notification for me). Latest activity first.
 */
export function filterThreads(threads: readonly CommentThread[], filter: ThreadFilter, uid: string | null, notified: ReadonlySet<string> = new Set()): CommentThread[] {
  const keep = (t: CommentThread) => {
    if (filter === 'all') return true;
    if (filter === 'open') return !t.resolvedAt;
    if (filter === 'resolved') return !!t.resolvedAt;
    return !!uid && (t.createdBy === uid || t.participantIds.includes(uid) || notified.has(t.id));
  };
  return threads.filter(keep).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}
